export default __webpack_public_path__ + "static/zapier-6a4d1a5e2076319697d38c71f5d7a1b0.png";